/**
 * <s-card-looks> — Male / Female switch on a product card.
 *
 * Panels carry data-card-look="<key>"; option buttons carry data-look-option="<key>"
 * and aria-pressed. The host's data-look reflects the active look so CSS (the
 * sliding pill) can follow it. Incoming photos fade in; reduced motion swaps instantly.
 */
class SCardLooks extends HTMLElement {
  #ac;

  connectedCallback() {
    this.panels = [...this.querySelectorAll('[data-card-look]')];
    this.options = [...this.querySelectorAll('[data-look-option]')];
    if (this.panels.length === 0 || this.options.length === 0) return;

    this.#ac = new AbortController();
    for (const option of this.options) {
      option.addEventListener('click', () => this.select(option.dataset.lookOption), { signal: this.#ac.signal });
    }
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  select(look) {
    if (!look || look === this.dataset.look) return;
    this.dataset.look = look;

    for (const option of this.options) {
      option.setAttribute('aria-pressed', String(option.dataset.lookOption === look));
    }

    let entering = null;
    for (const panel of this.panels) {
      const active = panel.dataset.cardLook === look;
      panel.hidden = !active;
      if (active) entering = panel;
    }

    const motion = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (motion && entering) {
      const easing = getComputedStyle(this).getPropertyValue('--ease-ui').trim() || 'cubic-bezier(0.16, 1, 0.3, 1)';
      entering.animate(
        [
          { opacity: 0, transform: 'scale(1.02)' },
          { opacity: 1, transform: 'none' },
        ],
        { duration: 450, easing }
      );
    }
  }
}

if (!customElements.get('s-card-looks')) {
  customElements.define('s-card-looks', SCardLooks);
}
